import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";

const monday = (iso) => {
  const d = new Date(iso);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return d;
};

export const weekly = (vivas, driving) => {
  const all = [...vivas.map((v) => [v.created_at, "cases"]), ...driving.map((d) => [d.created_at, "driving"])];
  if (!all.length) return [];
  const starts = all.map(([t]) => monday(t).getTime());
  const rows = new Map();
  for (let d = new Date(Math.min(...starts)); d.getTime() <= Math.max(...starts); d.setDate(d.getDate() + 7)) {
    rows.set(d.getTime(), { week: d.toLocaleDateString("en-AU", { day: "numeric", month: "short" }), cases: 0, driving: 0 });
  }
  all.forEach(([, k], i) => { const row = rows.get(starts[i]); if (row) row[k] += 1; });
  return [...rows.values()];
};

export const WeeklyChart = ({ data }) => (
  <div data-testid="weekly-chart" style={{ height: 220 }}>
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={{ top: 8, right: 8, left: -24, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--line)" vertical={false} />
        <XAxis dataKey="week" tick={{ fontSize: 11, fill: "var(--ink-3)" }} tickLine={false} axisLine={false} />
        <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "var(--ink-3)" }} tickLine={false} axisLine={false} />
        <Tooltip cursor={{ fill: "var(--muted-bg)" }} contentStyle={{ background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 8, fontSize: 12 }} labelFormatter={(w) => `Week of ${w}`} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar dataKey="cases" name="Cases" stackId="a" fill="var(--accent)" radius={[0, 0, 0, 0]} />
        <Bar dataKey="driving" name="Driving questions" stackId="a" fill="var(--warn)" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  </div>
);
